import React from 'react';
import styles from './Modal.module.css';

export interface ModalProps {
    children: React.ReactNode;
    onClickAway: () => void;
}

function Modal(props: ModalProps) {
    const { children, onClickAway } = props;
    return (
        <div
            className={styles.blackOverlay}
            onClick={onClickAway}
            role="dialog"
            aria-modal="true"
        >
            <div className={styles.verticalAligner} onClick={(e) => { e.stopPropagation() }}>
                <div className={styles.whiteWindow}>
                    <div className={styles.modalContent}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;
